export default __webpack_public_path__ + "static/media/rev_f_software_small.23564e09.webp";